import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


import { Link } from 'react-router-dom';
import moment from 'moment';


export default class ArchivedPollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            archivedPoll: [],
            loader: true

        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getArchivedPoll = this.getArchivedPoll.bind(this);
    }

    componentDidMount() {
        this.getArchivedPoll();
    }

    getArchivedPoll() {
        let status = this.props.statuses.find((e) => e.key === 'archived');
        localStorage.setItem('pollStatus', status.value);
        axios.get(`/questionnaire/all/${status.value}/`)
            .then(res => {
                const archivedPoll = res.data;
                this.setState({ archivedPoll, loader: false });
            })
            .catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške. Nije moguće prikazati prethodne ankete.');
                console.log('Failed to fetch archived poll.');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.archivedPoll;
    }

    render() {
        return (

            <div>


                { this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader  size="medium" active /></div> : this.getDataToRender().length ? <Table celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell >
                                Naziv
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Tip
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Datum objave
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Datum isteka
                            </Table.HeaderCell>

                            <Table.HeaderCell colSpan="1" ></Table.HeaderCell>


                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.getDataToRender().map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {el.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.questionnaireType.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {moment(el.activationDate).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {moment(el.endDate).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center" colSpan="1">
                                    {/* link */}
                                    <Link to={{ pathname: '/ankete/detalji' }}>
                                        <Button
                                            basic="true"
                                            color="blue"
                                            size="small"
                                            onClick={() => { // seta se flag da se moze editovati
                                                let poll = {
                                                    pollId: el.id,
                                                    pollName: el.name,
                                                    pollType: el.questionnaireType.id,
                                                    pollStatus: el.questionnaireStatus.id,
                                                };
                                                localStorage.setItem('poll', JSON.stringify(poll));
                                                localStorage.setItem('edit', 'disable');
                                                localStorage.removeItem('delete');
                                            }}
                                        > Detalji
                                        </Button>
                                    </Link>


                                </Table.Cell>
                            </Table.Row>))}
                    </Table.Body>
                </Table> : 'Trenutno nema arhiviranih anketa.'}


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollTabs/ArchivedPollList.js